import { useState } from 'react';
import { Button } from '@components/Button';
import { GenerateMoreModal } from '@components/GenerateMoreModal';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const GenerateMoreModalSection = () => {
  const [isGenerateMoreModalOpen, setIsGenerateMoreModalOpen] = useState(false);

  return (
    <>
      <section className={styles.section}>
        <SectionHeader
          title="Generate More Modal"
          description="Modal for generating additional leads by selecting cities from a searchable dropdown. Uses TypeAhead for city search and a table for managing selected cities."
          figmaNodeId="248-1692"
          styles={styles}
        />

        <div className={styles.subsection}>
          <h3 className={styles.subsectionTitle}>Interactive Demo</h3>
          <div className={styles.row}>
            <Button variant="primary" onClick={() => setIsGenerateMoreModalOpen(true)}>
              Open Generate More Modal
            </Button>
          </div>
          <p className={styles.hint}>
            This modal is used on the Generate Leads page when clicking "Generate More" button.
          </p>
        </div>

        <div className={styles.subsection}>
          <h3 className={styles.subsectionTitle}>Features</h3>
          <ul className={styles.featureList}>
            <li>TypeAhead search for cities with population data</li>
            <li>Add cities to table with "Add" button</li>
            <li>NumericStepper for adjusting # of leads per city</li>
            <li>Remove cities from table</li>
            <li>Empty state when no cities are added</li>
            <li>Save button disabled until cities are added</li>
          </ul>
        </div>
      </section>

      {/* Generate More Modal */}
      <GenerateMoreModal
        isOpen={isGenerateMoreModalOpen}
        onClose={() => setIsGenerateMoreModalOpen(false)}
        typeName="Dental Clinics"
        onGenerate={() => {
          setIsGenerateMoreModalOpen(false);
        }}
      />
    </>
  );
};
